import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Container, Row, Col, Alert, Image, Form, Button } from 'react-bootstrap';
import { authActions } from '../../store/auth';
import { config } from '../../config';

const CreateWorkspace = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token } = useParams();
    const [workspace, setWorkspace] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [createButtonDisabled, setCreateButtonDisabled] = useState(false);

    const handleCreate = async (e) => {
        e.preventDefault();

        if (!workspace) {
            setErrorMsg('Workspace name is required');
            return;
        }

        const regex = /^[a-zA-Z0-9_-]+$/;
        if (!regex.test(workspace)) {
            setErrorMsg('Workspace name is not valid. ( A-Z , a-z , 0-9 , _ , - )');
            return false;
        }

        setCreateButtonDisabled(true);
        const response = await fetch(`${config.url}/auth/create-workspace-with-token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ token, name: workspace })
        });

        const resData = await response.json();
        setCreateButtonDisabled(false);

        if (!response.ok) {
            let showErrorMsg = 'Error has occurred when trying to login';
            if (resData && resData.message) {
                showErrorMsg = resData.message + ' ';
            }
            if (resData && resData.data && resData.data[0] && resData.data[0].msg) {
                showErrorMsg += resData.data[0].msg;
            }
            setErrorMsg(showErrorMsg);
            return;
        }

        setErrorMsg('');

        localStorage.setItem('token', resData.token);

        const user = {
            userId: resData.userId,
            workspaceId: resData.workspaceId,
            workspaceName: resData.workspaceName,
            name: resData.name,
            firstName: resData.firstName,
            lastName: resData.lastName,
            email: resData.email,
            profileImage: resData.profileImage,
            workspaces: resData.workspaces,
        }

        localStorage.setItem('user', JSON.stringify(user));
        dispatch(authActions.login(user));

        navigate('/sys');
    }

    const handleEnterKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleCreate(e);
        }
    }

    return (
        <div style={{ backgroundColor: '#29303d', width: '100%', height: '100vh' }}>
            <Container>
                <Row className="justify-content-md-center text-center pt-4">
                    <Col sm="12" md="4">
                        <Image src="/images/floworglogo.png" style={{ width: '80%' }} />
                    </Col>
                </Row>
                <Row className="justify-content-md-center text-center pt-4">
                    <Col sm="12" md="4">
                        <h3 style={{ color: '#fed78e' }}>Create Workspace</h3>
                    </Col>
                </Row>
                {errorMsg &&
                    <Row className="justify-content-md-center mt-3">
                        <Col sm="12" md="4">
                            <Alert variant="danger">{errorMsg}</Alert>
                        </Col>
                    </Row>
                }
                <Row className="justify-content-md-center mt-3">
                    <Col sm="12" md="4">
                        <Form>
                            <Form.Group className="mb-4" controlId="formGroupEmail">
                                {/* <Form.Label style={{ color: '#fed78e' }}>Workspace name</Form.Label> */}
                                <Form.Control
                                    type="text"
                                    placeholder="Workspace name"
                                    onChange={(e) => { setWorkspace(e.target.value) }}
                                    onKeyDown={handleEnterKeyPress}
                                />
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
                <Row className="justify-content-md-center text-center mt-5">
                    <Col sm="12" md="4">
                        <Button
                            variant="gray"
                            style={{ backgroundColor: '#fed78e', color: '#29303d', width: '150px' }}
                            onClick={handleCreate}
                            disabled={createButtonDisabled}>Create</Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default CreateWorkspace;
